/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './material/material.module';
import { AppRoutingModule } from './app-routing.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ChartsModule } from 'ng2-charts';
import { DecimalPipe } from '@angular/common';
import {FileUploadModule} from 'ng2-file-upload';

import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';


import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
} from '@nebular/theme';


//Compents
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { CompanyProfileComponent } from './master-files/company-profile/company-profile.component';
import { AddCustomerComponent } from './master-files/customer-master/add-customer/add-customer.component';
import { ViewCustomersComponent } from './master-files/customer-master/view-customers/view-customers.component';
import { AddSupplierComponent } from './master-files/supplier-master/add-supplier/add-supplier.component';
import { ViewSupplierComponent } from './master-files/supplier-master/view-supplier/view-supplier.component';
import { EmployeeComponent } from './master-files/employee-master/employee/employee.component';
import { EmployeeListComponent } from './master-files/employee-master/employee-list/employee-list.component';
import { VehicleRegisterComponent } from './master-files/vehicle-register/vehicle-register/vehicle-register.component';
import { VehicleRegisterListComponent } from './master-files/vehicle-register/vehicle-register-list/vehicle-register-list.component';
import { LocationComponent } from './master-files/location/location.component';
import { ContainerTypeComponent } from './master-files/container-type/container-type.component';

import { ItemComponent } from './products/item-master/item/item.component';
import { ItemListComponent } from './products/item-master/item-list/item-list.component';

import { PurchaseOrderComponent } from './purchase/purchase-order/purchase-order/purchase-order.component';
import { PurchaseOrderListComponent } from './purchase/purchase-order/purchase-order-list/purchase-order-list.component';
import { PurchaseInvoiceComponent} from './purchase/purchase-invoice/purchase-invoice/purchase-invoice.component';
import { PurchaseInvoiceListComponent } from './purchase/purchase-invoice/purchase-invoice-list/purchase-invoice-list.component';
import { PurchaseReturnComponent } from './purchase/purchase-return/purchase-return/purchase-return.component';
import { PurchaseReturnListComponent } from './purchase/purchase-return/purchase-return-list/purchase-return-list.component';
import { PaymentComponent } from './purchase/payment/payment/payment.component';
import { PaymentListComponent } from './purchase/payment/payment-list/payment-list.component';

import { QuotationComponent } from './sale/quotation/quotation/quotation.component';
import { QuotationListComponent } from './sale/quotation/quotation-list/quotation-list.component';
import { AddInvoiceComponent } from './sale/invoice/add-invoice/add-invoice.component';
import { InvoiceListComponent } from './sale/invoice/invoice-list/invoice-list.component';
import { SaleReturnComponent } from './sale/sale-return/sale-return/sale-return.component';
import { SaleReturnListComponent } from './sale/sale-return/sale-return-list/sale-return-list.component';
import { ReceiptComponent } from './sale/receipt/receipt/receipt.component';
import { ReceiptListComponent } from './sale/receipt/receipt-list/receipt-list.component';

import { ExpenseComponent } from './expenses/expense/expense/expense.component';
import { ExpenseListComponent } from './expenses/expense/expense-list/expense-list.component';

import { BankAccountsComponent } from './banks/bank-accounts/bank-account/bank-accounts.component';
import { ChequeListComponent } from './banks/cheques/cheque-list.component';
import { CashBankEntryComponent } from './banks/cash-bank-entry/cash-bank-entry/cash-bank-entry.component';
import { CashBankEntryListComponent } from './banks/cash-bank-entry/cash-bank-entry-list/cash-bank-entry-list.component';
import { CashFlowComponent } from './banks/cash-flow/cash-flow.component';


import { UsersComponent } from './users/users/users.component';
import { UserListComponent } from './users/users/user-list.component';
import { UserTypesComponent } from './users/user-types/user-types.component';
import { UserPermissionComponent } from './users/user-permission/user-permission.component';
import { SettingsComponent } from './settings/settings/settings.component';
import { ChangePasswordComponent } from './settings/change-password/change-password.component';
import { BankAccountListComponent } from './banks/bank-accounts/bank-account-list/bank-account-list.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

import { MatConfirmDialogComponent } from './mat-confirm-dialog/mat-confirm-dialog.component';




//Reports

import { CustomerOutstandingReportComponent } from './reports/customer-outstanding-report/customer-outstanding-report.component';
import { SupplierOutstandingReportComponent } from './reports/supplier-outstanding-report/supplier-outstanding-report.component';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { IncomeStatementComponent } from './reports/income-statement/income-statement.component';
import { ExpensesAnalysisReportComponent } from './reports/expenses-analysis-report/expenses-analysis-report.component';
import { PurchaseReportComponent } from './reports/purchase-report/purchase-report.component';
import { ItemSalesReportComponent } from './reports/item-sales-report/item-sales-report.component';
import { BackupComponent } from './backup/backup.component';


import { ResetPasswordComponent } from './users/reset-password/reset-password/reset-password.component';
import { ResetPasswordListComponent } from './users/reset-password/reset-password-list/reset-password-list.component';
import { ResetPasswordRequestComponent } from './users/reset-password-request/reset-password-request.component';

//Services
import { CompanyProfileService} from './shared/services/company-profile.service';
import { CustomerService } from './shared/services/customer.service';
import { EmployeeService } from './shared/services/employee.service';
import { InvoiceService } from './shared/services/invoice.service';
import { AuthGuard } from './shared/guards/auth.guard';
import { UserService } from './shared/services/user.service';
import { AuthService } from './shared/services/auth.service';
import { AutoLogoutService } from './shared/services/auto-logout.service';


import { TokenInterceptorService  } from './shared/services/token-interceptor.service';
import { EnvServiceProvider } from './shared/services/env.service.provider';
import { PermissionListResolverService } from './shared/services/permission-list-resolver.service';

//Directives
import { AllowNumberOnlyDirective } from './shared/guards/allow-number-only.directive';
import { InvoiceReportComponent } from './reports/invoice-report/invoice-report.component';















@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    DashboardComponent,
    LoginComponent,
    MatConfirmDialogComponent,
    CompanyProfileComponent,

    AddCustomerComponent,
    AddSupplierComponent,
    ViewCustomersComponent,
    ViewSupplierComponent,
    AddInvoiceComponent,
    InvoiceListComponent,
    
    
    EmployeeComponent,
    EmployeeListComponent,
    VehicleRegisterComponent,
    VehicleRegisterListComponent,
    ItemComponent,
    ItemListComponent,
    UsersComponent,
    UserListComponent,
    UserTypesComponent,
    UserPermissionComponent,
    ReceiptComponent,
    ReceiptListComponent,
    PurchaseOrderComponent,
    PurchaseOrderListComponent,
    PurchaseInvoiceComponent,
    PurchaseInvoiceListComponent,
    PaymentComponent,
    PaymentListComponent,
    ExpenseComponent,
    ExpenseListComponent,
    CustomerOutstandingReportComponent,
    SupplierOutstandingReportComponent,
    SalesReportComponent,
    IncomeStatementComponent,
    ExpensesAnalysisReportComponent,
    PurchaseReturnComponent,
    SaleReturnComponent,
    SaleReturnListComponent,
    PurchaseReturnListComponent,
    SettingsComponent,
    QuotationComponent,
    QuotationListComponent,
    BankAccountsComponent,
    ChequeListComponent,
    CashFlowComponent,
    CashBankEntryComponent,
    CashBankEntryListComponent,
    PurchaseReportComponent,
    ChangePasswordComponent,
    BankAccountListComponent,
    FileUploadComponent,

    AllowNumberOnlyDirective,

    ItemSalesReportComponent,



     BackupComponent,
     ResetPasswordComponent,
     ResetPasswordListComponent,
     ResetPasswordRequestComponent,
     LocationComponent,
     ContainerTypeComponent,
     InvoiceReportComponent,
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    AppRoutingModule,
    FileUploadModule,
    ChartsModule,
    BsDatepickerModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbCardModule,
    ThemeModule.forRoot(),
    ToastrModule.forRoot(),

  ],
  providers: [
    CompanyProfileService,
    CustomerService,
    EmployeeService,
    InvoiceService,
    UserService,
    AuthService,
    AutoLogoutService,
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService, 
      multi: true 
    },
    AuthGuard,
    EnvServiceProvider,
    DecimalPipe,
    PermissionListResolverService
   
  
    
    ],
  bootstrap: [AppComponent],
  entryComponents:[
    MatConfirmDialogComponent,
    UsersComponent,
    CashBankEntryComponent,
    BankAccountsComponent,
    FileUploadComponent,
   ],
})
export class AppModule {
}
